<div class="reset-password">
  <div class="reset-password__form">
    <mat-form-field appearance="standard">
      <mat-label class="email__label">{{'Email address' | translate}}</mat-label>
      <input
        (keydown.enter)="submit()"
        [formControl]="emailFormControl"
        [placeholder]="'Email address' | translate"
        class="email__input"
        matInput>
      <mat-error *ngIf="emailFormControl.hasError('email')">
        {{'Incorrect email address' | translate}}
      </mat-error>
      <mat-error *ngIf="emailFormControl.hasError('required')">
        {{'Email address required' | translate}}
      </mat-error>
    </mat-form-field>

    <button
      (click)="submit()"
      [disabled]="emailFormControl.invalid"
      class="button button--rainbow reset-password__submit-button"
    >{{'Reset password' | translate}}</button>
  </div>
</div>
